import RequestOpenapiUpgradeModal from './RequestOpenapiUpgradeModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// Wrapper di `RequestOpenapiUpgradeModal` con mode='feature' fissato.
// Esposto come componente dedicato per chiarezza nei call-site del lead detail
// (richiesta di attivazione integrazione vs. upgrade quota).
export default function RequestOpenapiActivationModal({ isOpen, onClose }: Props) {
  return <RequestOpenapiUpgradeModal isOpen={isOpen} mode="feature" onClose={onClose} />;
}
